import React from 'react'
import Bar from './component/bar'
import Tabs from './component/tabs'

export default function Home({db, user}){
    return(<div>
        <Bar/>
        <Tabs db={db} user={user}/>
    </div>)
}